// RecommendedCars.jsx
export default function RecommendedCars() {
  return <h1>Recommended Cars Page</h1>;
}
